module.exports = __webpack_public_path__ + "static/media/img001.a8820db3.jpg";